import vuetify from "@/main";
import timeEntryModal from '@/modules/time/timeEntryModal.vue';
// vuetify() hands the component straight to createApp(), so these have to be
// real components - passing () => import(...) makes Vue treat the thunk as a
// functional component and the view renders nothing.
import ExpenseEditModal from '@/modules/expenses/ExpenseEditModal.vue';
import QBOexpense from '@/modules/expenses/QBOexpense.vue';
import CreateChargeModal from '@/modules/fixedfees/components/CreateChargeModal.vue';
angular.module('leanlaw').config(['$stateProvider', '$urlRouterProvider', function ($stateProvider, $urlRouterProvider) {
  $stateProvider.state('billing.invoice', {
    track: 'Billing:Invoice',
    url: "/invoice",
    views: {
      '': {
        template: "<div ui-view></div>"
      }
    }
  }).state('billing.invoice.summary', {
    url: "/summary",
    views: {
      '': {
        template: require('./views/staging.html'),
        controller: 'InvoiceStagingCtrl'
      }
    }
  }).state('billing.invoice.matter', {
    track: 'Billing:Invoice Matter',
    url: "/matter",
    template: require('./views/matter.html'),
    controller: 'InvoiceMatterCtrl',
    params: {
      mattersIds: undefined
    }
  }).state('billing.invoice.builder', {
    url: "/builder",
    views: {
      '': {
        template: require('./views/builder.html'),
        controller: 'InvoiceBuilderCtrl'
      }
    }
  }).state('billing.invoice.builder.entry', {
    track: 'Time:Edit',
    url: "/entry/{entryId}",
    params: {
      expanded: true,
      adjustments: true
    },
    views: {
      'edit': {
        template: require('../../time/views/edit.html'),
        controller: 'EntryEditCtrl'
      }
    }
  }).state('billing.invoice.builder.entry2', {
    track: 'Time:Edit',
    url: "/entry2/{entryId}",
    params: {
      expanded: true,
      adjustments: true
    },
    views: {
      'edit': {
        ...vuetify(timeEntryModal)
      }
    }
  }).state('billing.invoice.matter.expense', {
    track: 'Expense:Edit',
    url: "/expense/{expenseId}",
    params: {
      method: 'Invoice Page'
    },
    views: {
      edit: {
        ...vuetify(ExpenseEditModal)
      }
    }
  }).state('billing.invoice.matter.qbexpense', {
    url: "/qbexpense/{expenseId}",
    views: {
      'edit': {
        ...vuetify(QBOexpense)
      }
    }
  }).state('billing.invoice.matter.entry', {
    track: 'Time:Edit',
    url: "/entry/{entryId}",
    params: {
      expanded: true,
      adjustments: true
    },
    views: {
      'edit': {
        template: require('../../time/views/edit.html'),
        controller: 'EntryEditCtrl'
      }
    }
  }).state('billing.invoice.matter.entry2', {
    track: 'Time:Edit',
    url: "/entry2/{entryId}",
    params: {
      expanded: true,
      adjustments: true
    },
    views: {
      'edit': {
        ...vuetify(timeEntryModal)
      }
    }
  }).state('billing.invoice.matter.charge', {
    url: "/edit/{chargeId}",
    views: {
      'edit': {
        ...vuetify(CreateChargeModal)
      }
    },
    params: {
      chargeId: null,
      ledes: false,
      showAllocation: false,
      showClientMatter: false,
      fixedFeeTemplate: false,
      // stops the modal navigating to the matter's fixed fee page on save
      stayOnRoute: true
    }
  }).state('billing.invoice.matter.entry.add', {
    track: 'Matter:Create',
    url: "/add",
    views: {
      'edit': {
        template: require('../../matters/views/create.html'),
        controller: 'MatterCreateCtrl'
      }
    }
  });

  // The invoice preview step that used to live at
  // billing.invoice.matter.create (views/editor.html) is gone. The Create
  // Draft Invoice button on billing.invoice.matter now creates the invoice
  // straight from what is selected there, and everything about the invoice
  // itself is changed from Drafts. editor.html, InvoiceEditorCtrl,
  // InvoiceEntryEditCtrl, the llInvoiceLineItem directive and
  // invoiceEditorService are still on disk but no longer routed.
  // views/item.edit.html and InvoiceItemEditCtrl are still in use - they are
  // routed by billing.review.draft.view.item.
}]);